/* prettier-ignore */
export function setupHotjar(event: string) {
  if (import.meta.client) {
    setTimeout(() => {
      const w = window as any
      w.hj = w.hj || function(...args: unknown[]){(w.hj.q = w.hj.q || []).push(args)}
      w.hj('event', event)
      w.hj('event', [event])
    }, 0)
  }
}
